import clsx from 'clsx'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import MoreOutlined from '@/assets/icons/menu-vertical.svg?react'
import Button, { type ButtonSize } from '@/components/Button/Button'
import ButtonIcon from '@/components/ButtonIcon/ButtonIcon'
import Drawer from '@/components/Drawer/Drawer'

import styles from './ActionsDrawer.module.scss'
import type { Action } from '../BasicLayout/Actions'

export type DrawerAction = Action & { isDanger?: boolean }

type ActionsDrawerProps = {
  actions: DrawerAction[]
  onlyMobile?: boolean
  triggerButton?: React.ReactNode
  triggerButtonSize?: ButtonSize
}

const ActionsDrawer = (props: ActionsDrawerProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const { t } = useTranslation('common')

  return props.actions.length ? (
    <Drawer
      open={isDrawerOpen}
      onOpenChange={setIsDrawerOpen}
      trigger={
        props.triggerButton ? (
          props.triggerButton
        ) : (
          <ButtonIcon
            ariaLabel={t('button.actions')}
            variant="secondary"
            size={props.triggerButtonSize || 'small'}
            className={clsx(props.onlyMobile && styles.drawerTrigger)}
          >
            <MoreOutlined />
          </ButtonIcon>
        )
      }
      title={t('help.actions')}
    >
      <ul>
        {props.actions
          .filter(action => !action.hidden)
          .map((action, index) => {
            const {
              hidden: _,
              variantAction: __,
              variantButton: ___,
              isDanger,
              text,
              icon,
              onClick,
              ...actionProps
            } = action

            return (
              <li key={index} className={styles.item}>
                <Button
                  {...actionProps}
                  variant="tertiary"
                  className={styles.actionButton}
                  onClick={() => {
                    setIsDrawerOpen(false)
                    onClick?.()
                  }}
                >
                  <div
                    className={clsx(
                      styles.action,
                      isDanger && styles.actionDanger
                    )}
                  >
                    <span className={styles.icon}>{icon}</span>
                    <span>{text}</span>
                  </div>
                </Button>
              </li>
            )
          })}
      </ul>
    </Drawer>
  ) : null
}

export default ActionsDrawer
